import { gql } from "~/__generated__"

export const API_MONITORING_STATS_QUERY = gql(/* GraphQL */ `
  query ApiMonitoringStatsQuery($period: ApiMonitoringPeriod!) {
    apiMonitoringStats(period: $period) {
      totalRequests
      requestsByStatusOverTime {
        bucket
        ok
        rateLimited
        badRequest
        timeout
      }
      requestsByPlatform {
        platform
        count
      }
      requestsByInfluencer {
        influencerId
        influencerName
        count
      }
      successRate
      rateLimitRate
      timeoutCount
    }
  }
`)
